import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { LanguageService } from '../../../../../core/services/language.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-request-menu-2',
  imports: [CommonModule, FormsModule],
  templateUrl: './request-menu-2.component.html',
  styleUrl: './request-menu-2.component.css'
})
export class RequestMenu2Component {
  currentLang: string = 'TH';
  sub!: Subscription;
  constructor(
    private router: Router,
    private languageService: LanguageService
  ) {
    this.sub = this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
  }
  /* ------------------------------------ Function ------------------------------------ */
  goback() {
    this.router.navigate(['/home']);
  }
  goToMemberCard() {
    setTimeout(() => {
      this.router.navigate(['/member-vehicle-form']);
    }, 0);
  }
  goHome() {
    setTimeout(() => {
      this.router.navigate(['/home']);
    }, 0);
  }
}
